import { CoreProxyService, AppService, CoreTypes, LabelValue, IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts, SidebarContainerService, ClientCommonTypesModule, ReplaceLiteralsPipe, StringDateTimePipe, IMyDate, DateToDateTimeDTPipe } from "common-cloudstudio";
import { GearProxyService, GearAppService, GearTypes } from "common-gear";
import { Component, OnInit, ChangeDetectorRef, HostListener, OnDestroy, ViewChild, Renderer2 } from '@angular/core';
import { Chart, ChartOptions, ChartConfiguration, registerables, CategoryScale, LinearScale, PointElement, TimeScale, LineElement } from 'chart.js';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import zoomPlugin from 'chartjs-plugin-zoom';
import { DatePipe } from "@angular/common";
import { Subscription, forkJoin } from 'rxjs';
import moment from 'moment';
Chart.register(...registerables, zoomPlugin, CategoryScale, LinearScale,PointElement,TimeScale,LineElement);

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrls: ['./historical-data.component.scss']
})
export class HistoricalDataComponent implements OnInit, OnDestroy {

  _endpointsFullList: CoreTypes.SimpleEndpoint[];
  _variablesFullList: CoreTypes.VariablesTypeData[];
  _variablesList: LabelValue<number>[] = new Array<LabelValue<number>>();
  _timeInterval: LabelValue<number> = new LabelValue<number>();
  _timeIntervalsList: LabelValue<number>[] = new Array<LabelValue<number>>();
  _exportList: LabelValue<number>[] = new Array<LabelValue<number>>();
  _typeExport:LabelValue<number> = new LabelValue<number>();
  subscriptions: Subscription[] = [];
  _groups: Array<{
    endpoints: number[],
    endpointList: Array<IMultiSelectOption>,
    variable: LabelValue<number>,
  }> = [];
  _multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    selectionLimit: 5
  };
  _multiSelectTexts: IMultiSelectTexts;

  _chartData: any;
  _searchStatus: number = 0;
  _errorBackEnd: string;
  _facilityID: number;
  _type: number = 1;
  _calculated: {axisId: string; values: {max: number; min: number; avg: number}}[] = [];
  _zoomed = false;
  _onZoom: boolean = false;
  _datetimeFormat = 'dd/MM HH:mm';
  dateParam: CoreTypes.FormParameter = {
    ...new CoreTypes.FormParameter(),
    ParameterID: 1,
    UniqueParameterID: 'dateFrom',
    Prompt: this._gearAppService.GearCommonLiterals?.Period,
    ParameterType: CoreTypes.FormParameterType.DateTimeRange,
    ValueDateStartExpression: 'now/d',
    ValueDateEndExpression: 'now'
  };
  newDateParam: CoreTypes.FormParameter = {
    ...new CoreTypes.FormParameter(),
    ParameterID: 1,
    UniqueParameterID: 'dateFrom',
    ParameterType: CoreTypes.FormParameterType.DateTimeRange
  };
  maxDate: number;
  decimalSeparator: string = '.';
  offLinePeriods: boolean = false;

  constructor(
    public _appService: AppService,
    private _gearProxyService: GearProxyService,
    public _gearAppService: GearAppService,
    public _coreProxyService: CoreProxyService,
    private _gearService: GearAppService,
    private cdRef: ChangeDetectorRef,
    private _sidebarContainerService: SidebarContainerService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private replaceLiteralsPipe: ReplaceLiteralsPipe,
    private dateToDateTimeDT: DateToDateTimeDTPipe,
    private datePipe: DatePipe,
    private datetimePipe: StringDateTimePipe
  ) { }

  ngOnInit() {
    this.subscriptions.push(this._activatedRoute.params.subscribe(params => {
      if (!params || (params && !params.type)) {
        this._router.navigate(['comparative'], {replaceUrl: true, relativeTo: this._activatedRoute});
        return;
      }
      this._type = (params.type === 'comparative') ? 1 : 2;
      this._chartData = null;
      this._errorBackEnd = '';
      this.setGroups();
    }));

    if(this._appService.getFacilityID()) this._facilityID = this._appService.getFacilityID();

    if (this._appService.CoreCommonLiterals && this._gearAppService.GearMonitorLiterals) {
      this.loadData();
    }

    this.subscriptions.push(this._gearAppService.onLiteralsSet.subscribe(() => {
      this.setLiterals();
    }));

    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }

      this.loadData();
      this._variablesList = [];
      this._timeIntervalsList = [];

      if(this._appService.getFacilityID()) {
        this._facilityID = this._appService.getFacilityID();
      }

      // Resetear valores
      this._searchStatus = 0;
      this._chartData = null;
    }));
  }

  ngOnDestroy() {
    this._sidebarContainerService.destroySidebar();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  loadData() {
    forkJoin([
      this.getRegionalFormats()
    ])
    .subscribe({
      complete: () => {
        this.setLiterals();
        this.getVariablesList();
        this.getEndpointList();
        // this.getTimeIntervals();
        this.setGroups();
      }
    });
  }

  getRegionalFormats() {
    return new Promise((resolve, reject) => {
      this._appService.regionalFormats.subscribe(formats => {
        if(!formats) return;
        resolve(formats);
      },
      error => {
        reject(error);
      })
    });
  }

  setLiterals() {
    this.dateParam.Prompt = this._gearAppService.GearCommonLiterals?.Period;
    if(this._appService.regionalFormats?.value?.Frontend?.DecimalSeparator)
      this.decimalSeparator = this._appService.regionalFormats.value.Frontend.DecimalSeparator;
    this._multiSelectTexts = {
      checkAll: this._appService.CoreCommonLiterals?.MultiSelect_All_Male, // 'Select all'
      uncheckAll: this._appService.CoreCommonLiterals?.None_Male, // 'Unselect all'
      checked: this._appService.CoreCommonLiterals?.MultiSelect_X_Selected_Male, // 'item selected'
      checkedPlural: this._appService.CoreCommonLiterals?.MultiSelect_X_Selected_Male,
      searchPlaceholder: this._appService.CoreCommonLiterals?.MultiSelect_Find, //'Find'
      defaultTitle: this._appService.CoreCommonLiterals?.Select, // 'Select'
      allSelected: this._appService.CoreCommonLiterals?.MultiSelect_All_Male // 'All selected'
    };
    //variable para boton exportar mediante custom-select
    this._exportList = [
      {
        label:this._appService.CoreCommonLiterals.ExportJPG,
        value: 1
      },
      {
        label:this._appService.CoreCommonLiterals.ExportCSV,
        value: 2
      }
    ]
  }

  setGroups() {
    this._groups = [{
      endpoints: [],
      endpointList: new Array<IMultiSelectOption>(),
      variable: {label: this._appService.CoreCommonLiterals?.None_Female, value: null},
    }];

    if (this._type === 1) {
      this._groups.push({
        endpoints: [],
        endpointList: new Array<IMultiSelectOption>(),
        variable: {label: this._appService.CoreCommonLiterals?.None_Female, value: null},
      });
    }
  }

  getEndpointList() {
    this._coreProxyService.DeviceService.EnumSimpleEndpointsForFacility(
      this._appService.getAccessToken(),
      this._facilityID,
      data => {
        this._endpointsFullList = data;
      },
      error => {
        this._appService.showException(error);
      }
    )
  }

  getEndpoints(i: number) {
    let variable = this._variablesFullList.find(item => item.VariableTypeID === this._groups[i].variable.value);
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this._groups[i].endpoints = [];
    if (!variable) { return; }
    this._endpointsFullList.forEach(x => {
      // Filtrar listado de endpoints
      if (
        variable &&
        (
          variable.ApplicableEndpointTypes.indexOf(x.EndpointType) < 0 ||
          (variable.IsCustom && variable.VariableTypeID !== x.VariableTypeID)
        )
      ) { return; }

      let item = {
        name: x.DisplayText ? x.DisplayText : x.Description,
        id: x.EndpointID.toString()
      }

      optionsList.push(item);
    })

    this._groups[i].endpointList = optionsList;
  }

  getVariablesList() {
    this._variablesList = [{
      value: null,
      label: this._appService.CoreCommonLiterals?.None_Female
    }];

    this._gearProxyService.MasterEntityService.EnumVariableTypes(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this._facilityID,
      0,
      data => {
        this._variablesFullList = data;
        let _variablesList = [];

        data.forEach(item => {
          if (!item.AllowedForEndpointHistory || item.VariableTypeID === CoreTypes.EndpointVariableType.Text) { return; }
          const option = {
            label: item.Description,
            value: item.VariableTypeID
          };

          _variablesList.push(option);
        });

        this._variablesList = this._variablesList.concat(_variablesList);
      },
      error => {
        this._appService.showException(error);
      }
    )
  }

  @HostListener('window:keydown.enter', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
    this.search();
  }

  getTimeIntervals() {
    this._timeIntervalsList = [];
    this._coreProxyService.MasterEntityService.ParseDateFormParameter(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      this.dateParam,
      res => {
        this._timeIntervalsList = [
          {
            value: 5,
            label: this.replaceLiteralsPipe.transform(this._gearAppService.GearCommonLiterals.XMinutes, [5])
          },
          {
            value: 15,
            label: this.replaceLiteralsPipe.transform(this._gearAppService.GearCommonLiterals.XMinutes, [15])
          },
          {
            value: 60,
            label: this._gearAppService.GearCommonLiterals.OneHour
          },
          {
            value: 360,
            label: this.replaceLiteralsPipe.transform(this._gearAppService.GearCommonLiterals.XHours, [6])
          },
          {
            value: 1440,
            label: this._gearAppService.GearCommonLiterals.OneDay
          }
        ];

        let defaultItem = 2;
        const dateFrom = res.ValueDateStart;
        const dateTo = res.ValueDateEnd;
        const timeDif = new Date(dateTo.Date.Year, dateTo.Date.Month, dateTo.Date.Day).getTime()
          - new Date(dateFrom.Date.Year, dateFrom.Date.Month, dateFrom.Date.Day).getTime();
        const daysDif = timeDif / (1000 * 3600 * 24);

        if (daysDif > 31) {
          this._timeIntervalsList.splice(0, 3);
          defaultItem = 0;
        } else if (daysDif > 15) {
          this._timeIntervalsList.splice(0, 2);
          defaultItem = 0;
        } else if (daysDif > 7) {
          this._timeIntervalsList.splice(0, 1);
          defaultItem = 0;
        }

        // this._datetimeFormat = daysDif === 0 ? 'HH:mm' : 'D/MM HH:mm';
        this._timeInterval = this._timeIntervalsList[defaultItem];
      },
      err => this._appService.showException(err)
    )
  }

  search(dateParameters?) {
    this._errorBackEnd = null;
    this._calculated = [];

    if(this._chartData) {
      this._chartData.destroy();
      this._chartData = null;
    }

    if(this._groups[0].variable.value === null || !this._groups[0].endpoints.length ||
      (this._groups[1] && (this._groups[1].variable.value === null || !this._groups[1].endpoints.length))) {
      this._errorBackEnd = this._appService.CoreCommonLiterals?.PleaseCompleteMandatoryFields;
      return;
    }

    this._searchStatus = 1;

    let chartParams: CoreTypes.EndpointHistoryParams = new CoreTypes.EndpointHistoryParams();

    if(this._groups[0].variable.value !== null) {
      let endpoints1: CoreTypes.WidgetEndpointSettings[] = [];
      if(this._groups[0].endpoints.length) {
        this._groups[0].endpoints.forEach(endpoint => {
          endpoints1.push({
            EndpointID: endpoint,
            AggregationType: CoreTypes.EndpointHistoryAggregationType.None,
            GranularityMinutes: null,
            IncludeOfflinePeriods: this.offLinePeriods,
            DelayedTimeRangeEndExpression: '',
            DelayedTimeRangeStartExpression: ''
          })
        })
        chartParams.LeftAxis = {
          Endpoints: endpoints1,
          ChartType: this._groups[0].variable.value,
          AggregationType: CoreTypes.EndpointHistoryAggregationType.None
        };
      }
    }

    if(this._groups[1] && this._groups[1].variable.value !== null) {
      let endpoints2: CoreTypes.WidgetEndpointSettings[] = [];
      this._groups[1].endpoints.forEach(endpoint => {
        endpoints2.push({
          EndpointID: endpoint,
          AggregationType: CoreTypes.EndpointHistoryAggregationType.None,
          GranularityMinutes: null,
          IncludeOfflinePeriods: this.offLinePeriods,
          DelayedTimeRangeEndExpression: '',
          DelayedTimeRangeStartExpression: ''
        })
      })
      chartParams.RightAxis = {
        Endpoints: endpoints2,
        ChartType: this._groups[1].variable.value,
        AggregationType: CoreTypes.EndpointHistoryAggregationType.None
      };
    }

    this._gearProxyService.HistoricalDataService.GetEndpointStatusHistory(
      this._appService.getAccessToken(),
      chartParams,
      dateParameters ? dateParameters : this.dateParam,
      data => {
        this._datetimeFormat = data.XYChartWidgetData.TimeAxisFormat;
        this._onZoom = false;
        if(dateParameters) {
          this.newDateParam = dateParameters;
          this._onZoom = true;
        }
        setTimeout(() => {
          this._searchStatus = 0;
          this.buildChart(data);
        }, 50);
      },
      error => {
        this._errorBackEnd = error.Message;
        this._searchStatus = 0;
      }
    )
  }

  buildChart(data: CoreTypes.XYChartWidgetDefinitionAndData) {
    var lineChartData = {
			labels: [],
			datasets: []
    };

    data.XYChartWidgetData.Series.forEach((item, i) => {
      let axisId = 'y-axis-1';
      let seriesData = [];
      let milliseconds;
      const offlineSegments: Set<{start: number, end: number}> = new Set();
      
      item.Timestamps.forEach((time, x) => {
        const timestampMs = time * 1000;
        if(time > 0) {
          milliseconds = moment(timestampMs).toJSON().split('.')[0];
        }
        seriesData.push({
          x: milliseconds,
          xValue: timestampMs,
          y: item.Values[x],
          offline: false
        });
      });

      if (item.OfflinePeriods?.length && seriesData.length > 0 && this.offLinePeriods) {
        const dataMinX = Math.min(...seriesData.map(d => d.xValue));
        const dataMaxX = Math.max(...seriesData.map(d => d.xValue));

        item.OfflinePeriods.forEach(period => {
          const startXValue = period.StartTimestamp * 1000;
          const endXValue = period.EndTimestamp * 1000;

          const hasOverlap = startXValue <= dataMaxX && endXValue >= dataMinX;

          if (hasOverlap) {
            offlineSegments.add({ start: startXValue, end: endXValue });
          }
        });
      }

      if(this._groups[0] && i+1 > this._groups[0].endpoints.length)
        axisId = 'y-axis-2';

      const segment = {
        borderDash: (ctx) => {
          if (!ctx.p0 || !ctx.p1 || !offlineSegments.size) return undefined;
          const p0X = ctx.p0.raw?.xValue;
          const p1X = ctx.p1.raw?.xValue;
          
          if (p0X === undefined || p1X === undefined) return undefined;
          const isOffline = Array.from(offlineSegments).some(seg => 
            (p0X >= seg.start && p0X <= seg.end) || 
            (p1X >= seg.start && p1X <= seg.end) ||
            (p0X < seg.start && p1X > seg.end)
          );
          return isOffline ? [5, 5] : undefined;
        },
        borderColor: (ctx) => {
          if (!ctx.p0 || !ctx.p1 || !offlineSegments.size) return this.rgbToHexa(item.Color);
          const p0X = ctx.p0.raw?.xValue;
          const p1X = ctx.p1.raw?.xValue;
          
          if (p0X === undefined || p1X === undefined) return this.rgbToHexa(item.Color);
          const isOffline = Array.from(offlineSegments).some(seg => 
            (p0X >= seg.start && p0X <= seg.end) || 
            (p1X >= seg.start && p1X <= seg.end) ||
            (p0X < seg.start && p1X > seg.end)
          );
          return isOffline ? this.rgbToHexa(item.Color) + '80' : this.rgbToHexa(item.Color);
        }
      };

      lineChartData.datasets.push({
				label: item.Title,
				borderColor: this.rgbToHexa(item.Color),
				backgroundColor: this.rgbToHexa(item.Color),
				fill: false,
        data: seriesData,
				yAxisID: axisId,
        showLine: true,
        segment: segment
      });

      // Calcular minimo, maximo y promedio
      this.calculateValues(item.Values, axisId);
    });

    /**
     * ToDo: Traer desde el back las alarmas y ubicarlas en el dataset correspondiente
     * Debería haber un dataset por severidad de alarma con su color correspondiente.
     * Se le podría sumar un una cantidad X a "alarmValue" cuando la severidad des mayor.
     */
    /*let alarmValue = this.getAlarmsPosition();

    lineChartData.datasets.push({
      label: 'Alarma',
      id: 'alarms',
      borderColor: this.rgbToHexa(16750848),
      backgroundColor: this.rgbToHexa(16750848),
      fill: false,
      pointStyle: 'triangle',
      borderWidth: 8,
      data: [
        {
          x: Date.parse("2021-05-27 01:30"),
          y: alarmValue
        },
        {
          x: Date.parse("2021-05-27 02:30"),
          y: alarmValue
        }
      ],
      yAxisID: 'y-axis-1',
      showLine: false
    });*/

		let leftAxis = {};
    let rightAxis = {};
    if(data.XYChartWidgetData.LeftAxis) {
      leftAxis = {
        type: 'linear',
        display: true,
        position: 'left',
        id: 'y-axis-1',
        title: {
          display: true,
          text: data.XYChartWidgetData.LeftAxis.AxisTitle
        },
        // beginAtZero: true
      };
    }

    if(data.XYChartWidgetData.RightAxis) {
      rightAxis = {
        type: 'linear',
        display: true,
        position: 'right',
        id: 'y-axis-2',
        title: {
          display: true,
          text: data.XYChartWidgetData.RightAxis.AxisTitle
        },
        // beginAtZero: true
      };
    } else {
      rightAxis = {
        type: 'linear',
        display: false
      }
    }
    const options:ChartOptions<"line">= {
      maintainAspectRatio: false,
      responsive: true,
      interaction: {
        intersect: false,
        mode: 'nearest',
        axis:'x',
      },
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true,
            filter(item, data) {
              return data.datasets[item.datasetIndex].label !== 'alarms';
            },
          },
          display: true,
          onClick: (e, legendItem) => {
            var index = legendItem.datasetIndex;
            var ci = this._chartData;
            var meta = ci.getDatasetMeta(index);
            meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
            ci.update();

            this._calculated = [];
            this._chartData.data.datasets.forEach((dataset, i) => {
              if (!ci.getDatasetMeta(i).hidden && dataset.id !== 'alarms') {
                const yValues = dataset.data.map(d => d.y);
                this.calculateValues(yValues, dataset.yAxisID);
              } else if (dataset.id === 'alarms') {
                const alarmValue = this.getAlarmsPosition();
                dataset.data.forEach(v => v.y = alarmValue);
                ci.update();
              }
            });
          },
        },

        tooltip: {
          enabled: true,
          intersect: false,
          axis:'x',
          callbacks: {
            label: (data) => {
              if(data.dataset.yAxisID !== 'alarms') {
                return data.dataset.label + ': ' + data.formattedValue;
              } else {
                return 'titulo personalizado'
              }
            },
            title: (tooltipItems) => {
              const rawDate = (tooltipItems[0].raw as any).x;
              const date = new Date(rawDate);
              const pad = (n) => String(n).padStart(2, '0');
            
              const dateStr = `${pad(date.getMonth() + 1)}/${pad(date.getDate())}`;
              const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
            
              return `${dateStr} ${timeStr}`;
            }
          }
        },
        zoom: {
          zoom: {
            wheel: {
              enabled: false
            },
            drag: {
              backgroundColor: 'rgba(155, 155, 155, 0.2)',
              enabled: true
            },
            mode: 'x',
            onZoom: chart => {
              this.onExecuteZoom(chart);
            },
            onZoomComplete: () => { this._zoomed = true; }
          },
          limits: {
            y: { min: 1, max: 100 },
          },
        },
      },
      locale: this.decimalSeparator === '.' ? 'en-US' : 'es-ES',
      scales: {
        'y-axis-1': leftAxis,
        'y-axis-2': rightAxis,
        x: {
          display: true,
          grid: {
            color: "rgba(0,0,0,0.05)"
          },
          ticks: {
            display: true,
            maxRotation: 50,
            minRotation: 50,
            autoSkipPadding: 0,
            padding: 0
          },
          type: 'time',
          min: data.XYChartWidgetData.TimeAxisMin ? moment(this.datetimePipe.transform(data.XYChartWidgetData.TimeAxisMin)).valueOf() : undefined,
          max : data.XYChartWidgetData.TimeAxisMax ? moment(this.datetimePipe.transform(data.XYChartWidgetData.TimeAxisMax)).valueOf() : undefined,
          time: {
            unit:'hour',
            minUnit: 'hour',
            displayFormats: {
              day: this._datetimeFormat,
              minute: this._datetimeFormat,
              hour: this._datetimeFormat
            },
            tooltipFormat: (this._datetimeFormat.indexOf('h:mm') > -1) ? this._datetimeFormat : this._datetimeFormat+':ss',
            // parser: "YYYY/MM/DD HH:mm:ss",
          }
        }
      },
      animation: false,
    };
    const config: ChartConfiguration = {
      type: 'scatter',
      data: lineChartData,
      options: options
    }
    this._chartData = new Chart('canvas', config);
  }

  calculateValues(dataPoints, axisId: string) {
    let axisIndex = this._calculated.findIndex(item => item.axisId === axisId);
    if (axisIndex < 0) {
      axisIndex = this._calculated.push({axisId: axisId, values: {max: null, min: null, avg: null}})-1;
    }
    const values = this._calculated[axisIndex].values;

    const serieMax = Math.max.apply(null, dataPoints);
    values.max = (values.max === null || serieMax > values.max)
      ? serieMax
      : values.max;
    values.max = Math.round((values.max + Number.EPSILON) * 100) / 100;
    var valueFilter = dataPoints.filter(val => { return val !== null });
    const serieMin = Math.min.apply(null, valueFilter);

    values.min = (values.min === null || serieMin < values.min)
      ? serieMin
      : values.min;
    values.min = Math.round((values.min + Number.EPSILON) * 100) / 100;

    const sum = dataPoints.reduce((a, b) => a + b, 0);
    const serieAvg = (sum / dataPoints.length) || 0;
    values.avg = (values.avg === null)
      ? serieAvg
      : (values.avg+serieAvg)/2;

    values.avg = Math.round((values.avg + Number.EPSILON) * 100) / 100;
  }

  resetZoom() {
    this._chartData.resetZoom();
    this.search();
    this._zoomed = false;
  }

  toggleTooltips() {
    this._chartData.config.options.plugins.tooltip.enabled = !this._chartData.config.options.plugins.tooltip.enabled;
    this._chartData.update('none')
  }

  rgbToHexa(rgb: any) {
    let value = '000000' + rgb.toString(16);
    value = value.substring(value.length - 6);
    value = '#' + value;
    return value;
  }

  calculatePastDate(days: number): CoreTypes.DateTimeDT {
    var date = new Date();
    var last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
    var Day = last.getDate();
    var Month = last.getMonth()+1;
    var Year = last.getFullYear();
    return {
      ...new CoreTypes.DateTimeDT(),
      Date: {
        Day,
        Month,
        Year
      }
    };
  }

  onExecuteZoom(chart) {
    var test = chart.chart.scales.x;
    let min = chart.chart.scales.x.min;
    let max = chart.chart.scales.x.max;
    const init = Math.floor(new Date(min).getTime() / 1000);
    const end = Math.floor(new Date(max).getTime() / 1000);
    let initZoom = moment(init * 1000).format('YYYY-MM-DD HH:mm:ss');
    let endZoom = moment(end * 1000).format('YYYY-MM-DD HH:mm:ss');
    this.newDateParam.ValueDateStart = this.dateToDateTimeDT.transform(new Date(initZoom));
    this.newDateParam.ValueDateEnd =  this.dateToDateTimeDT.transform(new Date(endZoom));
    this.search(this.newDateParam);
  }

  getMaxValueDate(parameters) {
    let valueDateEndExpression
    this.maxDate = undefined;
    const maxDate = JSON.parse(JSON.stringify(parameters.ValueDateEnd));
    if(parameters.ValueDateEndExpression) {
      valueDateEndExpression = JSON.parse(JSON.stringify(parameters.ValueDateEndExpression));
    }

    if(maxDate) {
      let dateEnd = moment(this.datetimePipe.transform(maxDate)).valueOf();
      this.maxDate = dateEnd;
    } else if(valueDateEndExpression === 'now') {
      let date = moment(new Date()).valueOf()
      this.maxDate =  date;
    }
    return this.maxDate;
  }

  exportCsv() {
    let csvContent = "";
    const datasets = this._chartData.data.datasets;

    if (!datasets.length) { return; }

    // Header
    csvContent += this._appService.makeCsvColumn(this._gearAppService.GearCommonLiterals.Variable);
    csvContent += this._appService.makeCsvColumn(this._appService?.CoreCommonLiterals?.EndpointWord);
    csvContent += this._appService.makeCsvColumn(this._appService.CoreCommonLiterals.ValueText);
    csvContent += this._appService.makeCsvColumn(this._appService.CoreCommonLiterals.Date, true);

    // Convert Chart datasets into a simplified row array
    let rows: { variable: string; endpoint: string; value: string; datetime: string; }[] = [];
    datasets.forEach((item, d) => {
      item.data.forEach(di => {
        let dateTime;
        if(di?.x) {
          const time = di?.x?.split('.')[0];
          dateTime = time.replace(/T/g, ' ');
        }
        rows.push({
          variable: (this._groups[0] && d+1 > this._groups[0].endpoints.length)
            ? this._groups[1].variable.label
            : this._groups[0].variable.label,
          endpoint: item.label,
          value: di.y,
          datetime: dateTime,
        })
      });
    });

    // Sort columns by date
    rows = rows.sort((a, b) => {
      const timeA = new Date(a?.datetime).getTime() ?? 0;
      const timeB = new Date(b?.datetime).getTime() ?? 0;
      return timeA! - timeB!;
    });

    // Filter items without value and date
    rows = rows.filter(item => item.value && item.value !== "0" && item.datetime);

    // Parse array to CSV columns
    rows.forEach(columns => {
      let row = '';
      const columnsArray = Object.values(columns);
      columnsArray.forEach((value, i) =>
        row += this._appService.makeCsvColumn(value, i === columnsArray?.length - 1)
      );
      csvContent += row;
    });

    var encodedUri = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "endpoint-history.csv" + new Date().toLocaleString()+ ".csv");
    document.body.appendChild(link);

    link.click();
  }

  exportJpg() {
    var canvas = document.getElementById('canvas') as HTMLCanvasElement;
    var dataURL = canvas.toDataURL();
    var link = document.createElement("a");
    link.setAttribute("href", dataURL);
    link.setAttribute("download", "endpoint-history.jpg" + new Date().toLocaleString()+ ".jpg");
    document.body.appendChild(link);

    link.click();
  }

  getAlarmsPosition() {
    let alarmValue = 0;
    this._calculated.forEach((v, index) => {
      alarmValue += v.values.avg;
      if (index === this._calculated.length-1) { alarmValue = alarmValue/this._calculated.length; }
    });
    return alarmValue;
  }
}
